<template>
  <div>
    <h4 class="text-center">WhatsApp</h4>

    <div class="mt-5">
      <form @submit.prevent="promiseConnect = connect()">
        <div class="form-group row">
          <label class="col-4 text-muted col-form-label">
            Phone number:
          </label>
          <div class="col-8">
            <input class="form-control"
                   :class="{'is-invalid': serverErrorMessage}"
                   placeholder="+1 800 555 555"
                   v-model="phoneNumber"
                   maxlength="30"/>
            <div v-show="serverErrorMessage" class="invalid-feedback">
              {{ serverErrorMessage }}
            </div>
          </div>
        </div>

        <div>
          <b-button v-b-toggle.collapse-1
                    class="mt-4 pl-0"
                    variant="link"><icon class="btn-icon" name="question-circle" scale="1.0"></icon><span class="small">How to choose a phone number?</span></b-button>

          <b-collapse id="collapse-1" class="mt-2">
            <b-card class="bg-light">
              <ul class="m-2 text-muted">
                <li>It must include a country and area code.</li>
                <li>It will need to receive a call or SMS (applies for registration only).</li>
                <li>It mustn't have been used with WhatsApp Business API before. (If needed, the phone number can be migrated)</li>
                <li>Your company must own the number.</li>
                <li>For more details see the <a href="https://go.amio.io/docs-whatsapp-phone-number-registration">documentation</a>.</li>
              </ul>
            </b-card>
          </b-collapse>
        </div>

        <div class="row mt-5">
          <div class="col-12 d-flex justify-content-center">
            <button class="btn btn-primary px-5"
                    v-busy-button="promiseConnect">
              Create
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  import channelService from '@/services/amio-api/channel.service'
  import 'vue-awesome/icons/question-circle'

  export default {
    data() {
      return {
        promiseConnect: null,
        phoneNumber: '',
        serverErrorMessage: ''
      }
    },

    methods: {
      connect() {
        this.clearError()
        const data = {
          type: 'whatsapp',
          mode: 'sandbox',
          whatsapp_business_account: {
            phone_number: this.phoneNumber
          }
        }
        return channelService.create(data, [422])
          .then(channel => {
            this.channel = channel
            this.$router.push({name: 'administration.channel-detail.info', params: {id: channel.id}})
          })
          .catch((err) => {
            if (err.response.status !== 422) return

            const error = err.response.data.errors ? err.response.data.errors[0] : {}
            this.handleError(error)
          })
          .then(() => {
            this.promiseConnect = null
          })
      },

      clearError() {
        this.serverErrorMessage = ''
      },

      handleError(error) {
        this.serverErrorMessage = error.message
      }
    }
  }
</script>
